import { whenever } from "@vueuse/core";
import { nextTick, WatchCallback, WatchOptions, WatchSource } from "vue";

export function wheneverOnce<T>(
	source: WatchSource<T | false | null | undefined>,
	cb: WatchCallback<T>,
	options?: WatchOptions
) {
	const stop = whenever(
		source,
		(v, ov, onInvalidate) => {
			nextTick(() => stop());
			cb(v, ov, onInvalidate);
		},
		options
	);
}
